module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-SemiBoldItalic-WebS-6acd0ea25b31aa709dc956a607baef18.woff2";